/**
 * Graficos Data - Hospitais
 *
 * Gráfico 3: Contagens por Hospital (últimos 30 dias)
 * Gráfico 4: Atividade Últimos 7 Dias
 */

// ============================================================
// GRÁFICO 3: CONTAGENS POR HOSPITAL (últimos 30 dias)
// ============================================================

export interface ContagensPorHospitalData {
  hospital: string;
  contagens: number;
  porcentagem: number;
  ultimaContagem: string;
  diasDesdeUltima: number;
  statusAtividade: 'ATIVO' | 'ATENÇÃO' | 'INATIVO';
  tendencia: 'SUBINDO' | 'ESTÁVEL' | 'DESCENDO';
  variacaoVsMesAnterior: number;
}

export const contagensPorHospital: ContagensPorHospitalData[] = [
  {
    hospital: 'Hospital das Clínicas - FMUSP',
    contagens: 12,
    porcentagem: 12.6,
    ultimaContagem: '1 dia atrás',
    diasDesdeUltima: 1,
    statusAtividade: 'ATIVO',
    tendencia: 'SUBINDO',
    variacaoVsMesAnterior: 15
  },
  {
    hospital: 'Hospital Santa Lúcia',
    contagens: 10,
    porcentagem: 10.5,
    ultimaContagem: '2 dias atrás',
    diasDesdeUltima: 2,
    statusAtividade: 'ATIVO',
    tendencia: 'ESTÁVEL',
    variacaoVsMesAnterior: 0
  },
  {
    hospital: 'Hospital São Camilo',
    contagens: 11,
    porcentagem: 11.6,
    ultimaContagem: '1 dia atrás',
    diasDesdeUltima: 1,
    statusAtividade: 'ATIVO',
    tendencia: 'SUBINDO',
    variacaoVsMesAnterior: 10
  },
  {
    hospital: 'Hospital Albert Einstein',
    contagens: 9,
    porcentagem: 9.5,
    ultimaContagem: '1 dia atrás',
    diasDesdeUltima: 1,
    statusAtividade: 'ATIVO',
    tendencia: 'SUBINDO',
    variacaoVsMesAnterior: 12
  },
  {
    hospital: 'Hospital Mater Dei',
    contagens: 9,
    porcentagem: 9.5,
    ultimaContagem: '2 dias atrás',
    diasDesdeUltima: 2,
    statusAtividade: 'ATIVO',
    tendencia: 'ESTÁVEL',
    variacaoVsMesAnterior: -3
  },
  {
    hospital: 'Hospital Sírio-Libanês',
    contagens: 8,
    porcentagem: 8.4,
    ultimaContagem: '1 dia atrás',
    diasDesdeUltima: 1,
    statusAtividade: 'ATIVO',
    tendencia: 'SUBINDO',
    variacaoVsMesAnterior: 20
  },
  {
    hospital: 'Hospital Moinhos de Vento',
    contagens: 8,
    porcentagem: 8.4,
    ultimaContagem: '2 dias atrás',
    diasDesdeUltima: 2,
    statusAtividade: 'ATIVO',
    tendencia: 'ESTÁVEL',
    variacaoVsMesAnterior: 0
  },
  {
    hospital: 'Hospital Copa Star',
    contagens: 7,
    porcentagem: 7.4,
    ultimaContagem: '3 dias atrás',
    diasDesdeUltima: 3,
    statusAtividade: 'ATIVO',
    tendencia: 'ESTÁVEL',
    variacaoVsMesAnterior: -5
  },
  {
    hospital: 'Hospital Alemão Oswaldo Cruz',
    contagens: 7,
    porcentagem: 7.4,
    ultimaContagem: '2 dias atrás',
    diasDesdeUltima: 2,
    statusAtividade: 'ATIVO',
    tendencia: 'SUBINDO',
    variacaoVsMesAnterior: 8
  },
  {
    hospital: 'Hospital São Lucas da PUCRS',
    contagens: 6,
    porcentagem: 6.3,
    ultimaContagem: '1 dia atrás',
    diasDesdeUltima: 1,
    statusAtividade: 'ATIVO',
    tendencia: 'ESTÁVEL',
    variacaoVsMesAnterior: 0
  },
  {
    hospital: 'Hospital Nossa Senhora das Graças',
    contagens: 5,
    porcentagem: 5.3,
    ultimaContagem: '5 dias atrás',
    diasDesdeUltima: 5,
    statusAtividade: 'ATENÇÃO',
    tendencia: 'DESCENDO',
    variacaoVsMesAnterior: -15
  },
  {
    hospital: 'Hospital Vita Batel',
    contagens: 3,
    porcentagem: 3.2,
    ultimaContagem: '8 dias atrás',
    diasDesdeUltima: 8,
    statusAtividade: 'INATIVO',
    tendencia: 'DESCENDO',
    variacaoVsMesAnterior: -30
  }
];

// ============================================================
// GRÁFICO 4: ATIVIDADE ÚLTIMOS 7 DIAS
// ============================================================

export interface AtividadeDiariaData {
  dia: string;
  diaCompleto: string;
  contagens: number;
  produtos: number;
  hospitaisAtivos: number;
  horarioPico: string;
}

export const atividadeDiaria: AtividadeDiariaData[] = [
  {
    dia: 'Seg',
    diaCompleto: 'Segunda-feira, 04/10',
    contagens: 12,
    produtos: 456,
    hospitaisAtivos: 8,
    horarioPico: '08h-12h'
  },
  {
    dia: 'Ter',
    diaCompleto: 'Terça-feira, 05/10',
    contagens: 15,
    produtos: 583,
    hospitaisAtivos: 9,
    horarioPico: '09h-13h'
  },
  {
    dia: 'Qua',
    diaCompleto: 'Quarta-feira, 06/10',
    contagens: 18,
    produtos: 672,
    hospitaisAtivos: 10,
    horarioPico: '08h-14h'
  },
  {
    dia: 'Qui',
    diaCompleto: 'Quinta-feira, 07/10',
    contagens: 14,
    produtos: 521,
    hospitaisAtivos: 8,
    horarioPico: '10h-14h'
  },
  {
    dia: 'Sex',
    diaCompleto: 'Sexta-feira, 08/10',
    contagens: 23,
    produtos: 891,
    hospitaisAtivos: 11,
    horarioPico: '08h-12h'
  },
  {
    dia: 'Sáb',
    diaCompleto: 'Sábado, 09/10',
    contagens: 8,
    produtos: 287,
    hospitaisAtivos: 5,
    horarioPico: '08h-10h'
  },
  {
    dia: 'Dom',
    diaCompleto: 'Domingo, 10/10',
    contagens: 5,
    produtos: 143,
    hospitaisAtivos: 3,
    horarioPico: '09h-11h'
  }
];
